export default __webpack_public_path__ + "static/favicon-7ca410dc4717115d7a24a1215012fa8d.ico";